import clsx from 'clsx'
import { CountryCode, getCountryCallingCode } from 'libphonenumber-js/max'
import React, { PropsWithChildren, useImperativeHandle, useRef } from 'react'
import { IoChevronDown } from 'react-icons/io5'
import s from './PhoneNumberInput.module.scss'

interface Props {
  placeholder?: string
}
type NativeAttrs = Omit<React.ComponentPropsWithoutRef<'select'>, keyof Props>

export type PhoneCountrySelectProps = Props & NativeAttrs

const PhoneCountrySelectComponent = React.forwardRef<
  HTMLSelectElement,
  PropsWithChildren<PhoneCountrySelectProps>
>(
  (
    { className, required, disabled, placeholder, value, children, ...props },
    forwardedRef,
  ) => {
    // Handle ref forwarding
    const ref = useRef<HTMLSelectElement>(null)
    useImperativeHandle(forwardedRef, () => ref.current)

    return (
      <div className={clsx(className, s.callingCodeSelectWrapper)}>
        <div className={s.callingCodeDisplay}>
          <div className={s.flag}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              alt={value as string}
              src={`https://media.gubi.com/countries/${value}.svg`}
            />
          </div>
          <span>
            {value ? `+${getCountryCallingCode(value as CountryCode)}` : ''}
          </span>
        </div>
        <select
          required={required}
          disabled={disabled}
          defaultValue={placeholder ?? undefined}
          className={s.callingCodeSelect}
          {...props}
        >
          {placeholder && (
            <option value="" disabled={required} hidden={required}>
              {placeholder}
            </option>
          )}
          {children}
        </select>
        <IoChevronDown className={s.selectIcon} />
      </div>
    )
  },
)

const CountryOption: React.FC<
  React.PropsWithChildren<
    React.HTMLProps<HTMLOptionElement> & { value: string }
  >
> = (props) => <option {...props} />

PhoneCountrySelectComponent.displayName = 'PhoneCountrySelect'
const PhoneCountrySelect = Object.assign(PhoneCountrySelectComponent, {
  Option: CountryOption,
})
export default PhoneCountrySelect
